<div
  fxLayout="row"
  fxLayoutAlign="center center"
  [ngStyle]="{ 'min-height': '500px', height: '100vh', width: '95vw' }"
  class="u-position-relative u-margin-center"
>
  <ng-container *ngIf="tenantState | async as tenant; else showLoading">
    <div
      *ngIf="!userService.isLoggedIn()"
      class="u-position-absolute"
      [ngStyle]="{ top: '16px', left: '16px' }"
    >
      <a
        mat-icon-button
        [routerLink]="['/']"
        aria-label="Go home"
        i18n-aria-label="@@loginView.goHome"
      >
        <mat-icon>home</mat-icon>
      </a>
    </div>
    <div [ngStyle]="{ 'min-height': '424px' }">
      <div
        *ngIf="!canLogIn"
        class="bg-color-white u-padding-24"
        [ngStyle]="{ 'max-width': '400px' }"
      >
        <app-no-local-storage-prompt
          class="u-display-block"
        ></app-no-local-storage-prompt>
      </div>
      <ng-container *ngIf="canLogIn">
        <app-login
          class="u-display-block u-marginBottom-16"
          [defaultLoggedInUrl]="'/home'"
          [tenant]="tenant"
          [hasSignUpRedirect]="true"
        >
        </app-login>
        <ng-container
          *ngIf="
            !userService.isLoggedIn() &&
            (tenant?.email_login_enabled ||
              tenant?.integrations?.workos?.sso_signup_enabled)
          "
        >
          <p i18n="@@loginView.signupPrompt" class="u-textAlign-center">
            Don't have an account?<br /><button
              class="color-blue c-button"
              [routerLink]="['/signup']"
            >
              Sign up
            </button>
          </p>
          <div
            *ngIf="tenant.email_login_enabled"
            i18n="@@loginView.privacyDisclaimer"
            class="color-grey text-caption u-marginTop-16 u-textAlign-center"
            [ngStyle]="{ 'max-width': '400px' }"
          >
            This site is protected by reCAPTCHA and the Google
            <a class="color-blue" href="https://policies.google.com/privacy"
              >Privacy Policy</a
            >
            and
            <a class="color-blue" href="https://policies.google.com/terms"
              >Terms of Service</a
            >
            apply.
          </div>
        </ng-container>
      </ng-container>
    </div>
  </ng-container>
  <ng-template #showLoading>
    <app-progress-spinner class="display-block"></app-progress-spinner>
  </ng-template>
</div>
